import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";

const Confirmacao = () => {
    const handleRoute = () =>{ 
        window.location.href = "https://domatacadista.net";
      }

    return (
        <>  
            <div className="container">
                <NavBar />
                <div className="card">
                        <div className="h1 card-header text-center col-md-12 bg-primary">
                            Parabéns!! Agora você faz parte do Banco de Talentos do Dom.
                        </div>                  
                </div>
                <br />
                <div className="card">
                        <div className="h4 card-header text-center col-md-12 bg-primary">
                            <Link className="btn btn-primary btn-lg" onClick={handleRoute}>
                            Voltar para o Site do Dom
                            </Link>
                        </div>                  
                </div>
                <Footer />
            </div>
        </>
    );
}

export default Confirmacao;